module.exports = __webpack_public_path__ + "community.96205780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Upgrade/images/community.jpg
// module id = mwYU
// module chunks = 0